// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3CeGB","content":"styles__content___3vt8V","header":"styles__header___3Ovs5","logo":"styles__logo___2wBR7","main":"styles__main___14x6G"};